import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { get as _get } from 'lodash';

import { Party } from '@amfam/shared/models';
// Store
import { UserState } from '@amfam/shared/user';
import { ImpersonateRolesService } from '@amfam/shared/utility/impersonation';

import { ContactAdjuster } from '../contact-adjuster.model';

@Component({
  selector: 'app-contact-adjuster-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  standalone: false
})
export class ContactAdjusterFormComponent implements OnChanges {
  @Input() party: Party;
  @Input() customer = null as UserState;
  @Input() contactAdjusterSummary: string;
  @Input() contactAdjusterCommentHeader: string;
  @Input() contactAdjusterEmailHeader: string;
  @Output() contactInfo = new EventEmitter<ContactAdjuster>();

  private claimId: string;

  public contactAdjusterForm: UntypedFormGroup;
  public emailInput: AbstractControl;
  public phoneInput: AbstractControl;
  public commentInput: AbstractControl;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private location: Location,
    public roleService: ImpersonateRolesService
  ) {
    this.contactAdjusterForm = this.formBuilder.group({
      emailInput: ['', Validators.compose([Validators.required])],
      phoneInput: ['', Validators.compose([Validators.required])],
      commentInput: ['', Validators.compose([Validators.required, Validators.maxLength(850)])]
    });

    this.emailInput = this.contactAdjusterForm.controls['emailInput'];
    this.phoneInput = this.contactAdjusterForm.controls['phoneInput'];
    this.commentInput = this.contactAdjusterForm.controls['commentInput'];
  }

  ngOnChanges() {
    if (
      this.emailInput != null &&
      this.emailInput.value === '' &&
      typeof this.customer !== 'undefined'
    ) {
      this.emailInput.setValue(this.customer.emailAddress);
    }
    if (
      this.phoneInput != null &&
      this.phoneInput.value === '' &&
      typeof this.party !== 'undefined' &&
      this.party.primaryPhone !== null
    ) {
      this.phoneInput.setValue(_get(this.party, 'primaryPhone.tenDigitPhoneNumber', ''));
    }
    if (this.contactAdjusterForm !== null) {
      this.contactAdjusterForm.updateValueAndValidity();
    }
  }

  public cancel() {
    this.location.back();
  }

  public submit() {
    const contactInfo = new ContactAdjuster();
    contactInfo.firstName = this.party.firstName;
    contactInfo.lastName = this.party.lastName;
    contactInfo.email = this.emailInput.value;
    contactInfo.phone = this.phoneInput.value;
    contactInfo.comment = this.commentInput.value;

    this.contactInfo.emit(contactInfo);
  }
}
